var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { ChangeDetectionStrategy, Component } from '@angular/core';
import { ColumnBaseComponent } from '../base/columnbase.component';
import { ColumnService } from '../column/column.service';
import { ColumnBaseService } from '../base/columnbase.service';
var TextAreaComponent = /** @class */ (function (_super) {
    __extends(TextAreaComponent, _super);
    function TextAreaComponent(service, baseService) {
        var _this = _super.call(this, service, baseService) || this;
        _this.service = service;
        _this.baseService = baseService;
        return _this;
    }
    TextAreaComponent.prototype.ngOnInit = function () {
        _super.prototype.ngOnInit.call(this);
    };
    TextAreaComponent.decorators = [
        { type: Component, args: [{
                    selector: 'column-textarea',
                    template: '<textarea name="{{ colKey }}" attr.name="{{ colKey }}" [placeholder]="col" rows="{{ col.params?.options?.rows }}" [(ngModel)]="val" (change)="onChange(val)" [key]="key" [col]="col" columnDir></textarea>',
                    changeDetection: ChangeDetectionStrategy.OnPush
                }] }
    ];
    /** @nocollapse */
    TextAreaComponent.ctorParameters = function () { return [
        { type: ColumnService },
        { type: ColumnBaseService }
    ]; };
    return TextAreaComponent;
}(ColumnBaseComponent));
export { TextAreaComponent };
//# sourceMappingURL=textarea.component.js.map